import React, { useContext, useEffect, useState } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'
import '../Settings/styles.css'
import DefButton from '../Buttons/defbutton'
import ReplyIcon from '@mui/icons-material/Reply';
import { getSession } from '../../contexts/auth'
import { useWindowSize } from "@uidotdev/usehooks";
import { CalcWidthSize } from '../Settings'

import { externalComponent } from '../AppRoutes'

import AddCardIcon from '@mui/icons-material/AddCard';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ToPayReport from './ToPay'
import PaidReport from './Paid'
import ToReceiveReport from './ToReceive'
import ReceivedReport from './Received'
import CashflowReport from './CashFlow'

const MenuList = () => {

    const user = getSession()
    const permissions = user?.permissions

    return ({
        'topay': {
            title: 'Contas a pagar',
            icon: (<AddCardIcon />),
            obj: (<ToPayReport />),
            permission: (permissions.view_reports)
        },
        'paid': {
            title: 'Contas pagas',
            icon: (<PaymentIcon />),
            obj: (<PaidReport />),
            permission: (permissions.view_reports)
        },
        'toreceive': {
            title: 'Contas a receber',
            icon: (<ReceiptIcon />),
            obj: (<ToReceiveReport />),
            permission: (permissions.view_reports)
        },
        'received': {
            title: 'Contas recebidas',
            icon: (<ReceiptLongIcon />),
            obj: (<ReceivedReport />),
            permission: (permissions.view_reports)
        },
        'cashflow': {
            title: 'Fluxo de caixa',
            icon: (<PriceChangeIcon />),
            obj: (<CashflowReport />),
            permission: (permissions.view_reports)
        },
    })
}

const Relatorios = () => {
    const { isMobile } = useContext(externalComponent)
    const [selectedTab, setSelectedTab] = useState()
    const size = useWindowSize();

    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(()=>{
        window.backtobase = () => setSelectedTab()
    }, [])

    return (
        <>
            {!selectedTab ?
                <>
                    <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                        {itens.map(([key, value]) => (
                            <ColorButton
                                onClick={() => setSelectedTab(key)}
                                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                fColor={apptheme.primaryColor}
                                sColor={apptheme.tertiaryColor}>
                                <Box className='flexbox'>
                                    {value.icon}
                                    {value.title}
                                </Box>
                            </ColorButton>

                        ))}
                    </Box>
                </>
                :
                <>
                    <Box className={`settings-back-button ${isMobile ? '': 'hidden'}`}>
                        <DefButton
                            onClick={() => setSelectedTab()}
                        >
                            <ReplyIcon />
                        </DefButton>
                    </Box>
                    {MenuList()[selectedTab].obj}
                </>
            }

        </>
    )
}

export default Relatorios